// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__blNCd","list":"Breadcrumbs_list__bYPIX","item":"Breadcrumbs_item__dxLbb","separator":"Breadcrumbs_separator__Tycos"};